import I18n from 'I18n';
import * as React from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H2 } from 'UIComponents/elements/headings';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UISection from 'UIComponents/section/UISection';
import { getEventNameError, getEventNameErrorCopy } from 'automation-ui-enrollment/utils/webhookTriggerValidation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WebhookNameEventStep = ({
  triggerName,
  setTriggerName,
  setDisableNext
}) => {
  const [nameError, setNameError] = React.useState(null);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(UISection, {
      children: [/*#__PURE__*/_jsx(H2, {
        className: "text-center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.nameEvent.title"
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.nameEvent.description"
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.nameEvent.eventNameLabel"
        }),
        required: true,
        error: !!nameError,
        validationMessage: getEventNameErrorCopy(nameError),
        children: /*#__PURE__*/_jsx(UITextInput, {
          name: "webhook-trigger-name",
          placeholder: I18n.text('automation-ui-enrollment.webhookWizard.nameEvent.eventNamePlaceholder'),
          value: triggerName,
          onChange: event => {
            const newValue = event.target.value;
            const newNameError = getEventNameError(newValue);
            setTriggerName(newValue);
            setNameError(newNameError);
            setDisableNext(newNameError !== null);
          },
          onBlur: () => {
            if (!triggerName) {
              setNameError('MISSING');
            }
          }
        })
      })]
    })
  });
};
export default WebhookNameEventStep;